import type { ReactNode } from 'react';

export const symbol_laptop_chromebook: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M30-160q-12.75 0-21.37-8.68Q0-177.35 0-190.18 0-203 8.63-211.5 17.25-220 30-220h50v-560q0-24.75 17.63-42.38Q115.25-840 140-840h680q24.75 0 42.38 17.62Q880-804.75 880-780v560h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H30Zm386.59-60h128.82q8.59 0 14.59-6t6-15q0-9-6-15t-14.59-6H416.59q-8.59 0-14.59 6t-6 15q0 9 6 15t14.59 6ZM144-322h680v-458H144v458Zm340-229Z"
		/>
	</svg>
);
